module.exports = __webpack_public_path__ + "img/2.67af32f2.jpg";